export default __webpack_public_path__ + "static/media/gastro_1.d432f3d2.jpg";